// Channel descriptions for /invest and /borrow.
// Each channel can specify a primary CTA (cta + href) and optional secondary external links.

export const investChannels = [
  {
    title: "Direct deals",
    eyebrow: "Co-investment",
    body: "Co-investment alongside Daksfirst on individual transactions. Bespoke ticket sizes, with structures negotiated deal by deal. Open to professional and institutional investors only.",
    cta: "Discuss a co-investment",
    href: "mailto:info@daksfirst.com?subject=Co-investment%20enquiry"
  },
  {
    title: "Through funds",
    eyebrow: "Three jurisdictions",
    body: "Allocate to one of the three Daksfirst-managed funds. Each is structured for a different mandate and investor base.",
    items: [
      { label: "Cayman", text: "Emerging and Frontier Markets fund · target $100m" },
      { label: "Luxembourg", text: "Feeder vehicle into the Indian AIF and European investments · segregated compartments" },
      { label: "India", text: "Daksfirst India Special Situations Fund I · SEBI Cat II AIF · ~$200m" }
    ],
    cta: "View the funds",
    href: "/funds"
  },
  {
    title: "Through platforms",
    eyebrow: "Operating businesses",
    body: "Invest in Daksfirst's operating credit platforms. Suitable for investors looking for direct exposure to underlying loan books.",
    items: [
      { label: "UK Bridging",   text: "Forward-flow capacity and whole-loan portfolio sales" },
      { label: "Whole Loan",    text: "Loan portfolio sales for institutional buyers" },
      { label: "Hospitality",   text: "Direct credit and structured-equity exposure to UK and EU hospitality assets" },
      { label: "KIFPL (India)", text: "Co-investor capacity in Komac Investments and Finance Private Limited, the group's RBI-registered NBFC" }
    ],
    cta: "Request the platforms pack",
    href: "/data-room",
    extLinks: [
      { label: "kifpl.com",            href: "https://kifpl.com",                  logoSrc: null },
      { label: "ifhl.in",              href: "https://ifhl.in",                    logoSrc: "/logos/ifhl.jpg",   logoBg: "dark" },
      { label: "cepheusanalytics.com", href: "https://www.cepheusanalytics.com",   logoSrc: "/logos/cepheus.png" }
    ]
  }
];

export const borrowChannels = [
  {
    title: "Direct credit",
    eyebrow: "Bespoke structures",
    body: "Bespoke credit structures originated by the group and held in Daksfirst's regulated funds. Suitable for sponsors and corporates with transactions that require tailored terms.",
    items: [
      { label: "Size",     text: "$5m – $100m" },
      { label: "Maturity", text: "2 – 7 years" },
      { label: "Pricing",  text: "Floating + 5% to 15% (USD)" },
      { label: "Security", text: "1st ranking, mezzanine, preferred equity, recourse and non-recourse" }
    ],
    cta: "Apply for credit",
    href: "https://apply.daksfirst.com",
    external: true
  },
  {
    title: "UK platforms",
    eyebrow: "Daksfirst originated",
    body: "Specialist UK credit through Daksfirst's regulated lending platforms. Originated, underwritten and serviced in-house. All applications go through the central application portal.",
    items: [
      { label: "Bridging",    text: "Short-term residential and commercial bridging finance" },
      { label: "BTL",         text: "Buy-to-Let term lending for residential and commercial property" },
      { label: "Hospitality", text: "Senior, mezzanine and structured equity for hospitality assets" }
    ],
    cta: "Apply via the borrower portal",
    href: "https://apply.daksfirst.com",
    external: true,
    secondary: { label: "See lending products and terms", href: "/uk/lending-products" }
  },
  {
    title: "India",
    eyebrow: "RBI-registered NBFC",
    body: "Indian credit through Komac Investments and Finance Private Limited (KIFPL), the group's RBI-registered NBFC. KIFPL is mandated to provide private credit exposure across fintechs, origination platforms, and SME anchors and partners. India Finance House (IFHL) acts as the loan service provider.",
    items: [
      { label: "Entity",    text: "Komac Investments and Finance Private Limited" },
      { label: "Regulator", text: "Reserve Bank of India" },
      { label: "Office",    text: "Wadia Bldg, Fort, Mumbai" },
      { label: "LSP",       text: "India Finance House (IFHL)" }
    ],
    cta: "Visit kifpl.com",
    href: "https://kifpl.com",
    external: true,
    extLinks: [
      { label: "ifhl.in",              href: "https://ifhl.in",                  logoSrc: "/logos/ifhl.jpg",   logoBg: "dark" },
      { label: "cepheusanalytics.com", href: "https://www.cepheusanalytics.com", logoSrc: "/logos/cepheus.png" }
    ]
  }
];


export const wealthChannels = [
  {
    title: "Discretionary portfolio management",
    eyebrow: "Multi-asset",
    body: "Bespoke discretionary portfolios for UHNW individuals, single-family offices and multi-family offices. Mandates calibrated to risk tolerance, liquidity preferences and the client's existing balance sheet.",
    items: [
      { label: "Client",     text: "UHNW individuals, single-family offices, multi-family offices, Indian diaspora HNW" },
      { label: "Style",      text: "Discretionary, with optional advisory overlay" },
      { label: "Asset mix",  text: "Public markets, structured products, private credit and alternatives" }
    ]
  },
  {
    title: "Public markets",
    eyebrow: "Liquid allocations",
    body: "Equity and fixed-income portfolios managed across G7 and emerging markets. Direct lines, ETFs, mutual funds and managed account structures.",
    items: [
      { label: "Asset classes", text: "Equities, fixed income, multi-asset, ETFs" },
      { label: "Geography",    text: "G7 plus selective emerging markets" }
    ]
  },
  {
    title: "Structured products",
    eyebrow: "Bespoke notes",
    body: "Structured solutions sourced from a panel of investment-bank issuers. Capital-protected notes, autocallables, equity-linked notes and credit-linked structures, calibrated to client risk and yield targets.",
    items: [
      { label: "Issuers",     text: "Panel of major investment-bank counterparties" },
      { label: "Structures",  text: "Capital-protected, autocallable, equity-linked, credit-linked" }
    ]
  },
  {
    title: "Daksfirst private credit",
    eyebrow: "In-house allocations",
    body: "Allocations into the Daksfirst Group's own private credit transactions and managed funds — Cayman EM/FM, Luxembourg feeder, India SEBI Cat II AIF, plus direct deal co-investment.",
    items: [
      { label: "Vehicles",   text: "Cayman, Luxembourg, India SEBI Cat II AIF" },
      { label: "Direct",     text: "Co-investment alongside Daksfirst on individual transactions" }
    ],
    cta: "View the funds",
    href: "/funds"
  }
];
